import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  Cart,
  RestaurantCart,
  SelectedArticle,
} from "../../../../../../../interfaces/Catalogue";
import { updateCart } from "../../../../../../../store/cart/cartActions";
import {
  getPurchaseOfferMessage,
  getRemiseMessage,
} from "../../../../../../../utils/loyaltyUtils";
import {
  calculatediscountedPrice,
  calculateMenuFinalPrice,
  findPriceByTypeOrder,
} from "../../../../../../../utils/priceUtils";
import IngredientDetails from "../../../../../IngedientDetails/IngredientDetails";
import RewardClaimButton from "../../../../../RewardClaimButton/RewardClaimButton";

interface OrderMenuArticlePops {
  currentArticle: SelectedArticle;
  orderItemIndex: number;
  orderType: number;
  restaurantId?: number;
  categoryItemId: number;
  canApplyArticleDiscount: boolean;
  rewardClaimDisabled?: boolean;
  userLoyalityPoints?: number;
  totalLoyaltyPtsConsomed?: number;
}

const OrderMenuArticle = (props: OrderMenuArticlePops) => {
  const {
    orderItemIndex,
    currentArticle,
    orderType,
    restaurantId,
    categoryItemId,
    userLoyalityPoints,
    canApplyArticleDiscount,
    rewardClaimDisabled,
    totalLoyaltyPtsConsomed,
  } = props;

  // const [isRemiseActive, setIsRemiseActive] = useState(
  //   currentArticle?.selecteMenuItem.isRemiseActive || false
  // );

  const dispatch = useDispatch();
  const savedCategories = useSelector(
    (state: { cart: Cart }) => state.cart.savedCategories
  );

  const restaurantCart: RestaurantCart = savedCategories[restaurantId || 0];

  const priceByOrderType = findPriceByTypeOrder(
    currentArticle?.selecteMenuItem.typeOrderPrices,
    orderType
  );

  const updateArticleLoyality = (isRemiseActive: boolean) => {
    if (restaurantId) {
      // Clone savedCategories to avoid mutation
      let updatedSavedCart = { ...savedCategories };

      // Find the matching category
      const matchingCategory = updatedSavedCart[restaurantId]?.categories.find(
        (category, index) => {
          return category.id === categoryItemId && index === orderItemIndex;
        }
      );

      if (matchingCategory) {
        // Loop through orders and update the article
        matchingCategory.order?.forEach((order) => {
          order.selectedArticles.forEach((selectArticle) => {
            const { selecteMenuItem } = selectArticle;

            if (currentArticle.selecteMenuItem.id === selecteMenuItem.id) {
              // setIsRemiseActive(!selecteMenuItem.isRemiseActive);

              selecteMenuItem.isRemiseActive = !selecteMenuItem?.isRemiseActive;

              const priceByTypeOrder =
                findPriceByTypeOrder(
                  selecteMenuItem.typeOrderPrices,
                  restaurantCart.mode
                ) || 0;

              selecteMenuItem.discountedPrice = isRemiseActive
                ? calculatediscountedPrice(
                    priceByTypeOrder,
                    selecteMenuItem?.rewardDiscountType,
                    selecteMenuItem?.rewardDiscountValue
                  )
                : null;
            }
          });
        });

        const discountedPrice = calculateMenuFinalPrice(
          matchingCategory?.order || [],
          restaurantCart.mode,
          true
        );
        const originalPrice = calculateMenuFinalPrice(
          matchingCategory?.order || [],
          restaurantCart.mode,
          false
        );

        matchingCategory.discountedPrice =
          discountedPrice == originalPrice ? null : discountedPrice;

        // Dispatch updated cart
        dispatch(updateCart(updatedSavedCart));
      }
    }
  };

  return (
    <div key={currentArticle.selecteMenuItem.id} className="menusItemList">
      <div className="SingleMenuList">
        <Box
          display="flex"
          alignItems="center"
          gap={1}
          justifyContent="space-between"
        >
          <p className="menuSubName" style={{ textTransform: "uppercase" }}>
            {currentArticle?.selecteMenuItem?.quantity}{" "}
            {currentArticle?.selecteMenuItem?.name}{" "}
            {priceByOrderType > 0 && (
              <>
                <span> ( </span>
                <span
                  className={
                    currentArticle?.selecteMenuItem?.discountedPrice != null
                      ? "discount-price"
                      : ""
                  }
                >
                  {priceByOrderType} €
                </span>
                {currentArticle?.selecteMenuItem?.discountedPrice != null && (
                  <span>
                    {currentArticle?.selecteMenuItem?.discountedPrice === 0
                      ? " / Gratuit"
                      : ` / ${currentArticle?.selecteMenuItem?.discountedPrice} €`}
                  </span>
                )}
                <span> ) </span>
              </>
            )}
          </p>
          {canApplyArticleDiscount && (
            <RewardClaimButton
              articleClaimed={
                currentArticle?.selecteMenuItem.isRemiseActive || false
              }
              selecteMenuItem={currentArticle?.selecteMenuItem}
              updateArticleLoyality={updateArticleLoyality}
              isClaimDisabled={rewardClaimDisabled || false}
            />
          )}
        </Box>
        {currentArticle?.selecteMenuItem?.rewardTotalPtRequired &&
          canApplyArticleDiscount && (
            <p className="discountMessage">
              {getRemiseMessage(currentArticle?.selecteMenuItem)}
            </p>
          )}
        {currentArticle?.selecteMenuItem?.purchaseOffers && (
          <p className="discountMessage">
            {getPurchaseOfferMessage(
              currentArticle?.selecteMenuItem?.purchaseOffers
            )}
          </p>
        )}

        <IngredientDetails
          selectedIngredients={currentArticle?.selectedIngredients}
          orderType={orderType}
        />
      </div>
    </div>
  );
};

export default OrderMenuArticle;
